import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Sparkles, Zap, ShieldCheck, Coins, Mic } from 'lucide-react';

export const PremiumWelcomeModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="absolute inset-0 bg-black/60 backdrop-blur-sm pointer-events-none"
        />

        <motion.div
          initial={{ scale: 0.95, opacity: 0, y: 20 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          exit={{ scale: 0.95, opacity: 0, y: 20 }}
          className="relative w-full max-w-md bg-[#111] border border-[#333] rounded-3xl overflow-hidden shadow-2xl"
        >
          {/* Header Graphic matching SparkPremium */}
          <div className="relative pt-10 pb-6 flex flex-col items-center border-b border-[#333]/50">
            {/* Background Glow */}
            <div className="absolute -top-20 -right-20 w-64 h-64 bg-[#0BD9E5]/10 blur-[80px] rounded-full pointer-events-none" />
            
            <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[#0BD9E5] to-[#BD00FF] p-[2px] mb-4 shadow-[0_0_30px_rgba(11,217,229,0.2)]">
                <div className="w-full h-full bg-[#111] rounded-[14px] flex items-center justify-center">
                    <Sparkles size={32} className="text-[#0BD9E5]" />
                </div>
            </div>
            <h2 className="text-[28px] font-extrabold text-white tracking-tight mb-2">
              Welcome to Spark Premium
            </h2>
            <p className="text-gray-400 text-center text-sm px-6">Your subscription is active! You now have full access to our most exclusive features.</p>
          </div>

          <div className="p-6">
            <div className="space-y-5 mb-8 max-h-[300px] overflow-y-auto pr-2" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
              <div className="flex gap-4 items-start">
                <div className="w-10 h-10 rounded-xl bg-[#BD00FF]/10 flex items-center justify-center shrink-0">
                  <Coins className="text-[#BD00FF]" size={20} />
                </div>
                <div>
                  <h4 className="font-bold text-white text-[15px] mb-1">Creator Program</h4>
                  <p className="text-gray-500 text-[13px] leading-snug">Turn your viral shadows into real cash. Earn $0.10 for every 1,000 views.</p>
                </div>
              </div>

              <div className="flex gap-4 items-start">
                <div className="w-10 h-10 rounded-xl bg-green-500/10 flex items-center justify-center shrink-0">
                  <Mic className="text-green-500" size={20} />
                </div>
                <div>
                  <h4 className="font-bold text-white text-[15px] mb-1">Voices Unlocked</h4>
                  <p className="text-gray-500 text-[13px] leading-snug">Skip the queues and access exclusive 1-1 and 4-4 Rooms.</p>
                </div>
              </div>

              <div className="flex gap-4 items-start">
                <div className="w-10 h-10 rounded-xl bg-[#0BD9E5]/10 flex items-center justify-center shrink-0">
                  <Sparkles className="text-[#0BD9E5]" size={20} />
                </div>
                <div>
                  <h4 className="font-bold text-white text-[15px] mb-1">Premium Member Badge</h4>
                  <p className="text-gray-500 text-[13px] leading-snug">Get the exclusive Sparkle badge on your profile and stand out from the crowd.</p>
                </div>
              </div>

              <div className="flex gap-4 items-start">
                <div className="w-10 h-10 rounded-xl bg-[#FF4444]/10 flex items-center justify-center shrink-0">
                  <Zap className="text-[#FF4444]" size={20} />
                </div>
                <div>
                  <h4 className="font-bold text-white text-[15px] mb-1">Ad-Free Experience</h4>
                  <p className="text-gray-500 text-[13px] leading-snug">Enjoy a 100% ad-free experience. No distractions, just pure content.</p>
                </div>
              </div>

              <div className="flex gap-4 items-start">
                <div className="w-10 h-10 rounded-xl bg-yellow-500/10 flex items-center justify-center shrink-0">
                  <ShieldCheck className="text-yellow-500" size={20} />
                </div>
                <div>
                  <h4 className="font-bold text-white text-[15px] mb-1">Early Access</h4>
                  <p className="text-gray-500 text-[13px] leading-snug">Be the first to test drive experimental features before anyone else.</p>
                </div>
              </div>
            </div>

            <button
              onClick={onClose}
              className="w-full py-4 bg-gradient-to-r from-[#0BD9E5] to-purple-500 hover:from-[#09c2cd] hover:to-purple-600 text-black font-extrabold rounded-2xl transition-all shadow-[0_0_20px_rgba(11,217,229,0.2)]"
            >
              Start Exploring
            </button>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};
